import { FETCH_ANALYZE_DATA_STARTED, FETCH_ANALYZE_DATA_SUCCEEDED, FETCH_ANALYZE_DATA_FAILED, FETCH_ANALYZE_POINTS_STARTED, FETCH_ANALYZE_POINTS_SUCCEEDED, FETCH_ANALYZE_POINTS_FAILED, UPDATE_FREQUENCY, UPDATE_VIEW, CLEAR_PARAMS } from './ActionTypes';
import * as api from 'web-interactives-dashboard-ui/api/analyze';
import { getFrequency, getView } from 'web-interactives-dashboard-ui/selectors/analyze';
import { getFilterStateWithDateDefaults } from 'web-interactives-dashboard-ui/selectors/filterSelectors';
import { VIEWS } from 'web-interactives-dashboard-ui/constants/AnalyticsConstants';
import { fetchShortDetailsSuccess } from './DetailsActions';
export const updateFrequency = frequency => ({
  type: UPDATE_FREQUENCY,
  frequency
});
export const updateView = view => ({
  type: UPDATE_VIEW,
  view
});
export const clearParams = () => ({
  type: CLEAR_PARAMS
});
const fetchAnalyzeDataStart = () => ({
  type: FETCH_ANALYZE_DATA_STARTED
});
const fetchAnalyzeDataSuccess = response => ({
  type: FETCH_ANALYZE_DATA_SUCCEEDED,
  response
});
const fetchAnalyzeDataFailure = error => ({
  type: FETCH_ANALYZE_DATA_FAILED,
  error
});
export const fetchDataForAnalyze = contentId => (dispatch, getState) => {
  const state = getState();
  const filterParams = getFilterStateWithDateDefaults(state);
  const interactiveId = contentId || filterParams.interactiveId;
  dispatch(fetchAnalyzeDataStart());
  api.fetchDataForAnalyze(Object.assign({}, filterParams, {
    interactiveId
  }), getFrequency(state)).then(response => {
    dispatch(fetchAnalyzeDataSuccess(response));
    if (response.analyzeResponse.model) {
      dispatch(fetchShortDetailsSuccess(response.analyzeResponse.model));
    }
    const view = getView(state);
    const counters = response.analyzeResponse.totals.currentCounters;
    if (view !== 'VIEWS' && counters[VIEWS[view]] === 0) {
      dispatch(updateView('VIEWS'));
    }
  }).catch(error => {
    console.error(error);
    dispatch(fetchAnalyzeDataFailure(error));
  });
};
const fetchAnalyzePointsStart = () => ({
  type: FETCH_ANALYZE_POINTS_STARTED
});
const fetchAnalyzePointsSuccess = response => ({
  type: FETCH_ANALYZE_POINTS_SUCCEEDED,
  response
});
const fetchAnalyzePointsFailure = error => ({
  type: FETCH_ANALYZE_POINTS_FAILED,
  error
});
export const fetchPointsForFrequency = (frequency, contentId) => (dispatch, getState) => {
  const state = getState();
  const filterParams = getFilterStateWithDateDefaults(state);
  const interactiveId = contentId || filterParams.interactiveId;
  dispatch(fetchAnalyzePointsStart());
  api.fetchPointsForFrequency(Object.assign({}, filterParams, {
    interactiveId
  }), frequency).then(response => {
    dispatch(fetchAnalyzePointsSuccess(response));
  }).catch(error => {
    dispatch(fetchAnalyzePointsFailure(error));
  });
};